export const SHIFT_DISTANCE = 25;
